<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <div class="inner">
      <h1 v-translate>Operátorské štítky</h1>
    </div>
    <div class="inner_white">
        <div class="status search">
          <div class="field_left">
              <search-input input-class="search" v-model="formFields.search"></search-input>
          </div>
          <a
              v-if="$_createActionAllowed"
              :title="$gettext('Přidat operátorský štítek')"
              :class="['add', 'add_expand', { open: newOperatorTagOpen }, { btn_inactive: false}]"
              @click.prevent="toggleNewOperatorTag()"
              v-translate>Přidat štítek
          </a>
        </div>
      <div :class="['filter', 'expand_content', { open: newOperatorTagOpen }]">
        <div class="field_left">
          <p>
          <text-input
              id="tag-name-add-1"
              v-model="newOperatorTag.name"
              :required="true"
              ref="newoperatortagnameref"
          >
            <translate class="translate">Název operátorského štítku</translate>
          </text-input>
          </p>
        </div>
        <div class="field_right field_btn">
          <p class="field">
          <input
              type="submit"
              class="btn"
              :value="'Uložit' | translate"
              @click.prevent.stop="addNewOperatorTag"
          />
        </p>
        </div>
      </div>
      <form>
        <div class="scroll-wrapper">
          <div class="table_overflow" id="contentBox" data-table-id="operator-tags-list">
      <table class="vypis" ref="table_with_action_line">
        <thead>
        <tr v-if="entities.length > 0">
          <th class="no_padding drag_drop"></th>
          <th class="no_padding checkbox"/>
          <sorting-table-title
              v-for="title in operatorTagsTableTitles"
              :key="title.key"
              :column="title.column"
              :sort="getActiveSort(title.column)"
              @changeSorting="changeSorting"
          >{{ title.name }}</sorting-table-title>
          <th class="no_padding edit"></th>
        </tr>
        </thead>

        <operator-tag-row
            v-for="entity in entities"
            :entity="entity"
            :key="entity.id"
            :selectedEntities="selectedEntities"
            @input="select"
            @updateOperatorTag="updateEntity"
            @deleteOperatorTag="deleteEntity"
            :ref="'operator-tag-row-ref-'+entity.id"
        ></operator-tag-row>
        <tr v-if="entities.length === 0">
             <td colspan="8">{{ $gettext('Nebyly nalezeny žádné operátrské štítky.') }}</td>
        </tr>
      </table>
          </div>
        </div>
      <list-action-line
          :entities="entities"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="operator-tags-list"
          @limit="setLimit"
          @offset="setOffset"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
          ref="action_line"
      ></list-action-line>
      </form>
    </div>
  </div>
</template>

<script>
import OperatorTagRow from "@/components/views/operatorTags/OperatorTagRow"
import listActions from "@/components/mixins/list-actions"
import operatorTags from "@/components/views/operatorTags/mixins/operatorTags"

export default {
  name: "OperatorsTags",
  components: {
    OperatorTagRow,
  },
  mixins: [listActions, operatorTags],
  data() {
    return {
      moduleName: 'operator_tags',
      newOperatorTagOpen: false,
      newOperatorTag: {
        name: ''
      },
      formFields: {
        sort: {
          column: 'sName',
          direction: 'desc',
        }
      }
    }
  },
  created(OperatorTagService) {
    this.entityService = OperatorTagService
    this.createdInit();
  },
  computed: {
    operatorTagsTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název operátorského štítku'), column: 'sName'},
        {key: 2, name: this.$gettext('Počet operátorů'), column: 'sOperatorsCount'},
        {key: 3, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.operatorTagsTableTitles)
      headers.operators_count.callback = entity => {return entity.operator_count;};

      return headers;
    },
  },
  methods: {
    toggleNewOperatorTag() {
      this.newOperatorTagOpen = !this.newOperatorTagOpen
      this.$emit('new-operator-tag-open', this.newOperatorTagOpen)
      if (this.newOperatorTagOpen) {
        this.resetInput('newoperatortagnameref')
      }
    },
    addNewOperatorTag() {
      this.entityService.createEntity(this.newOperatorTag)
          .then(() => {
            this.getEntities()
            this.setSuccessMessage()
            this.$refs['newoperatortagnameref'].setForcedInvalid(false)
            this.newOperatorTagOpen = false;
          })
          .catch((error) => {
            this.setErrorMessage(this._processListErrorMessage(error))
          })
    },
    resetInput(ref) {
      this.$refs[ref].setForcedInvalid(false)
      this.$refs[ref].setTouched(false)
      this.newOperatorTag.name = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/operatorTags/OperatorTagsList.vue